import React from 'react'
import { ProductVertical, ProductVerticalProps } from './product-vertical'

import Cookies from 'js-cookie'
import useLinxMeta from 'src/util/hooks/useLinxMeta'

import * as gtg from '../../services/gtag'
import * as gtm from '../../services/gtm'

import { ProductApi } from 'src/types'
import { Product } from 'src/services/linx-api/dtos'

type ProductVerticalWithAnalyticsProps = {
  analyticsProduct?: ProductApi | Product
  isFavoritos?: boolean
  shouldSendLinxClickEventRequest?: boolean
  shouldSendGoogleAnalyticsEventRequest?: boolean
} & ProductVerticalProps

export const ProductVerticalWithAnalytics = ({
  analyticsProduct,
  product,
  onClick,
  shouldSendLinxClickEventRequest = true,
  shouldSendGoogleAnalyticsEventRequest = true,
  ...rest
}: ProductVerticalWithAnalyticsProps) => {
  const { triggerLinxProductViewClickEvent, makeLinxClickEventInputData } =
    useLinxMeta()

  const sendLinxClickEventRequest = async () => {
    const trackingUrl =
      analyticsProduct?.trackingUrl || analyticsProduct?.clickUrl || undefined
    const urlTokens = trackingUrl?.split('?')
    const queryParams = urlTokens?.[1].split('&')
    const trackingId = queryParams
      ?.find((param) => param.split('=')[0] === 'trackingId')
      ?.split('=')[1]
    const linxClickEventUri = urlTokens?.[0]
      ? `https://api.linximpulse.com${urlTokens[0]}`
      : undefined
    const deviceId = Cookies.get('nav_id') ? Cookies.get('nav_id') : ''
    const source = window.innerWidth > 480 ? 'desktop' : 'mobile'

    const linxClickEventInputData = makeLinxClickEventInputData(
      trackingId,
      deviceId,
      source
    )

    await triggerLinxProductViewClickEvent(
      linxClickEventInputData,
      linxClickEventUri
    )
  }

  const sendToGoogleAnalytics = () => {
    if (analyticsProduct?.selectedSku) {
      gtg.productClick(analyticsProduct)
      gtm.productClick(analyticsProduct)
    }
  }

  const handleProductClick = async (
    product: ProductVerticalProps['product']
  ) => {
    if (shouldSendLinxClickEventRequest) {
      await sendLinxClickEventRequest()
    }

    if (shouldSendGoogleAnalyticsEventRequest) {
      sendToGoogleAnalytics()
    }

    onClick?.(product)
  }

  return (
    <ProductVertical product={product} onClick={handleProductClick} {...rest} />
  )
}
